import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import { Box, Grid } from "@mui/material";
import { styled } from "@mui/system";
import { Row, Col } from "react-bootstrap";
import {
  Empty,
  message,
  Modal,
  Upload,
  Form,
  Input,
  Dropdown,
  Space,
  Button,
  Checkbox,
} from "antd";
import SecondSubMenu from "./SecondSubMenu";
import { Select } from "antd";
import { CALL_API } from "common/API";
import { find, get, isEmpty, map } from "lodash";
import { connect } from "react-redux";
import { toggleProcessingModal } from "redux/actions";
import { bindActionCreators } from "redux";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import GridBuilder from "UIBuilderEngine/GridBuilder";
import EditorConvertToHTML from "atoms/EditorConvertToHTML";
import { ReactComponent as UploadIcon } from "../../assets/fonts/Paperclip_Attechment_Tilt.svg";
import { DownOutlined } from "@ant-design/icons";
import EmailEditorStyle from "./EmailEditorStyle";
import { STATUS_CODE } from "common/Constants";
import axios from "axios";

const CustomizeTabPanel = styled(TabPanel)(({ theme }) => ({
  "&.root": {
    padding: 0,
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      width: "400px",
    },
  },
  width: "100%",
  padding: 0,
}));

const VerticalTab = styled(Tab)({
  textTransform: "none",
  color: "#636980",
  textAlign: "left",
  "&.MuiTabs-indicator": {
    width: "0px",
  },
  "&.Mui-selected": {
    borderRadius: "15px",
    border: "none",
    background: "#E3E8FC",
    color: "#1F243B",
  },
});
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

function VerticalTabs({
  candidateList,
  processList,
  jobList,
  getData,
  activeTab = "",
  processValue,
  setShowComponent,
  onboardCandidate,
  selectedItem,
  movetoChange,
  goBack,
  updateProcessingModal,
  index,
  setMovedModal,
  movedModal,
  handleMovedModalclose,
  setMovedStatusName
}) {
  const [localCandidateList, setLocalCandidateList] = React.useState([]);
  const [form] = Form.useForm();
  const [value, setValue] = React.useState(index);
  const [selectedCandidate, setSelectedCandidate] = React.useState(
    localCandidateList[value]
  );
  const [loading, setLoading] = React.useState(false);
  const [fileList, setFileList] = React.useState([]);
  const [appealDetails, setAppealDetails] = React.useState("");
  const [uploadKey, setUploadKey] = React.useState(0);
  const [editorKey, setEditorKey] = React.useState(0);
  const [editorModal, setEditorModal] = React.useState(false);
  const [hrPolicies, setHrPolicies] = React.useState(false);
  const [getCurrentCandidate, setGetCurrentCandidate] = React.useState();
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSelectedCandidate(localCandidateList[newValue]); // Update selected candidate
    // getData()
  };
  console.log("processValue121--->", processList);
  const handleCloseModal = () => {
    form.resetFields();
    setEditorModal(false);
  };
  const handlePoliciesModal = () => {
    form.setFieldValue("policies", []);
    setHrPolicies(false);
  };

  React.useEffect(() => {
    if (activeTab.toString() === "1") {
      const filteredCandidates = candidateList.filter(
        (candidate) =>
          candidate.currentStatus === processValue?.toString() &&
          candidate?.jobId === selectedItem?.jobId
      );
      setLocalCandidateList(filteredCandidates);
      setSelectedCandidate(filteredCandidates[0]);
    } else {
      setLocalCandidateList(candidateList);
      setSelectedCandidate(candidateList[value]);
    }
  }, [processValue]);
  // console.log("selectedCandidate---->", selectedCandidate);
  // console.log("localCandidateList---->", localCandidateList);
  const [changeStep, setChangeStep] = React.useState();
  const [formValues, setFormValues] = React.useState({});
  console.log("formValues---->", formValues);
  const handleValuesChange = (changedValues, allValues) => {
    //  console.log("changedValues---->", changedValues);
    setFormValues((prev) => {
      const updatedState = { ...prev };

      // Iterate through changedValues to add `[name]: value` explicitly
      Object.entries(changedValues)?.forEach(([name, value]) => {
        updatedState[name] = value || ""; // Set to `""` if value is undefined/null
      });

      return updatedState; // Return the updated state
    });
  };
  

  const moveToTalentPool = async () => {
    updateProcessingModal(true);
    await CALL_API(
      `recruitment/candidate/${selectedCandidate?.candidateId}`,
      "patch",
      {
        talentPoolStatus: true,
      }
    );
    updateProcessingModal(false);
    message.success("Moved to Talent Pool");
    getData();
    goBack();
    // Remove the selected candidate from the local candidate list
    const updatedLocalCandidateList = localCandidateList.filter(
      (candidate) => candidate.candidateId !== selectedCandidate.candidateId
    );

    setLocalCandidateList(updatedLocalCandidateList);
    setSelectedCandidate(updatedLocalCandidateList[0]);
    setValue(0);
    setLoading(false);
  };

  const getProcess = () => {
    const process = find(processList, {
      processId: selectedCandidate?.processId,
    });

    if (process) {
      // setGetCurrentCandidate(process)
      const steps = get(process, "steps", []);
      //   const currentStatus = record?.currentStatus || '0';
      return steps;
    }
    return [];
  };

  const getProcessData = () => {
    const process = find(processList, {
      processId: selectedCandidate?.processId,
    });
    console.log("process121--->", process)
    if (process) {
      // setGetCurrentCandidate(process)
      const steps = get(process);
      //   const currentStatus = record?.currentStatus || '0';
      return process.checkbox;
    }
    return false;
  };

    const formatSteps = (stepsArray) => {
    const defaultSteps = ["Interview", "Not Selected", "Selected"];
    const result = [];

    const flatSteps = [];

    stepsArray?.forEach(obj => {
      const value = Object.values(obj)[0]; // get the string value from the object
      if (typeof value === "string") {
        const parts = value.split(",").map(s => s.trim());
        flatSteps.push(...parts);
      }
    });

    // Remove duplicates
    const uniqueSteps = [...new Set(flatSteps)];

    // Separate default and custom steps
    const customSteps = uniqueSteps.filter(
      step => step !== "New" && !defaultSteps.includes(step)
    );
    const hasNew = uniqueSteps.includes("New");

    let index = 0;

    if (hasNew) {
      result.push({ [index++]: "New" });
    }

    customSteps?.forEach(step => {
      result.push({ [index++]: step });
    });

    defaultSteps?.forEach(step => {
      result.push({ [index++]: step });
    });

    return result;
  };

  const getStepsData = getProcess();
  console.log("getStepsData--->", getProcessData());
  const processCheckbox = getProcessData();
  const formatStepsData = formatSteps(getStepsData);
  console.log("formatStepsData--->", formatStepsData)
  console.log("candidateId121--->", selectedCandidate?.candidateId)
  const transformedSteps = formatStepsData.map((step) => {
    const key = Object.keys(step)[0];
    const value = step[key];
    return { value: key, label: value };
  });


  // const transformedSteps = Object.entries(formatStepsData).map(([key, value]) => ({
  //   value: key,
  //   label: value
  // }));
  const valueToLabelMap = Object.fromEntries(
    transformedSteps?.map((opt) => [opt.value, opt.label])
  );
  console.log("transformedSteps121---->", transformedSteps)
  // console.log("valueToLabelMap---->", valueToLabelMap)
  const tabheight = { maxHeight: "80vh" };
  // console.log("getCurrentCandidate---->", getCurrentCandidate);
  // const [movedModal, setMovedModal] = React.useState(false);
  // const handleMovedModalclose = () => setMovedModal(false)

  // React.useEffect(() => {
  //   setTimeout(() => (
  //     setMovedModal(false)
  //   ), 3000)
  // }, [movedModal])

  const handleSelectChange = async (value) => {
    // console.log("value---->", value)
    setChangeStep(value);
    const updatedCandidate = {
      ...selectedCandidate,
      currentStatus: value,
    };
    // movetoChange(value)
    // Update the state with the new candidate object
    let subject = "";
    if (valueToLabelMap[value] === "Interview") {
      subject = "Progress Update: Next Steps in Your Application Process";
    } else if (valueToLabelMap[value] === "Selected") {
      subject = "Selected! - Sales Representative (Job Offer)";
    } else if (valueToLabelMap[value] === "Not Selected") {
      subject = "Progress Update: Next Steps in Your Application Process";
    }
  form.setFieldsValue({ subject });
    const updatedLocalCandidateList111 = localCandidateList?.find(
      (candidate) => {
        if (candidate.candidateId === selectedCandidate?.candidateId) {
          return candidate;
        }
      }
    );

    setSelectedCandidate(updatedCandidate);
    // Update the localCandidateList with the updatedCandidate
    const updatedLocalCandidateList = localCandidateList.map((candidate) => {
      if (candidate.candidateId === selectedCandidate?.candidateId) {
        return updatedCandidate;
      } else {
        return candidate;
      }
    });
    const subjectValue = form.getFieldValue("subject") || "";
    // Set the updated localCandidateList state
    setGetCurrentCandidate(updatedLocalCandidateList111);
    setLocalCandidateList(updatedLocalCandidateList);
    // console.log("step--->",valueToLabelMap[value]);
    setMovedStatusName(valueToLabelMap[value])
    // if(valueToLabelMap[value] === "Interview" || valueToLabelMap[value] === "Not Selected" || valueToLabelMap[value] === "Selected"){
    //   setEditorModal(true);
    // }else{
    let position = "";
    if (valueToLabelMap[changeStep] === "Selected") {
      const match = (appealDetails || "").match(/Position:\s*([^\n<]+)/i);
      if (match && match[1]) {
        position = match[1].trim();
      }
    }
    const obj = {
      // "emailId": "snrudhra2004@gmail.com",
      // "applicationstatus": "Disqualified",
      // "bodyText": "",
      // "checkbox": true,
      // "jobId": "8",
      // "subject": "",
      // "position": "Sales Representative",
      // "currentStatus": "4"
      emailId: selectedCandidate?.emailId || "",
      applicationstatus: valueToLabelMap[value],
      bodyText: appealDetails || "",
      checkbox: processCheckbox,
      jobId: selectedCandidate?.jobId,
      subject: subjectValue || "",
      position: position,
      currentStatus: value,
    }
    
      if(processCheckbox){
        // updateProcessingModal(true);
        // setEditorModal(false);
        const response = await axios.patch(`https://nz9pn78wqi.execute-api.ap-south-1.amazonaws.com/Prod/recruitment/candidate/${selectedCandidate?.candidateId}`,
           obj,
           {
            headers: {
              Tymeplusjwt: window.localStorage.getItem("token") || "",
            }
          }
        )
        // const response = await CALL_API(
        //   `recruitment/candidate/${selectedCandidate?.candidateId}`,
        //   "patch",
        //   obj
        // );
        console.log("res121--->", response)
        if(response.data.response.code === 200 && response.data.response.available === true){
          updateProcessingModal(false);
          setMovedModal(true)
          goBack();
          getData();
          message.success("Email sent successfully")
        }else if(response.data.response.code === 400 || response.data.response.available === false){
          if(valueToLabelMap[value] === "Interview" || valueToLabelMap[value] === "Not Selected" || valueToLabelMap[value] === "Selected" || valueToLabelMap[value] === "Not Selected"){
            setEditorModal(true);
            updateProcessingModal(false);
          }
        }
      }else{
        // await CALL_API(
        //   `recruitment/candidate/${selectedCandidate?.candidateId}`,
        //   "patch",
        //   obj
        //   // {
        //   //   currentStatus: value,
        //   // }
        // );
        setEditorModal(true);
        updateProcessingModal(false);
      }
      
    // }
    
    // handleSendEmail()
    // updateProcessingModal(true);
    // await CALL_API(
    //   `recruitment/candidate/${selectedCandidate?.candidateId}`,
    //   "patch",
    //   {
    //     currentStatus: value,
    //   }
    // );
    // updateProcessingModal(false);
    // goBack();
    // getData();
  };

  const getMailContent = (applicationstatus) => {
    if (applicationstatus === "Interview") {
      return `Dear Candidate,<br />We are pleased to inform you that you have successfully passed the “Initial screening” and are now moving forward to the next stage of our hiring process “Group Discussion” for the Sales Representative position at Waila Technology. <br /><br/>Thank you for your continued interest. <br /><br/>Regards,<br />Waila Technology`;
    }
    if (applicationstatus === "Not Selected") {
      return `Dear Candidate, <br/>Thank you for your intreset in the Sales Representative position at Waila Technology. After careful consideration, we regret to inform you that we have decided to move forward with other candidates whose qualifications more closely match our requirements. <br/><br/>We wish you the best in your job search. <br/><br/>Regards, <br/>Waila Technology`;
    }
    if (applicationstatus === "Selected") {
      return `Dear Candidate, <br/>We are pleased to inform you that you have been selected for the position of Sales Representative at Waila Tech. Congratualations! <br/><br/>Offer Details: <br/>Position: Sales Representative <br/>Start Date: [Enter date] <br/>Salary: [Enter Amount] <br/><br/>If you accept this offer, kindly complete the form in the link below on or before [Enter date]. We are excited about the possibility of you joining our team and contributing to our success.`;
    }
    return "";
  };

  React.useEffect(() => {
  if (editorModal) {
    setAppealDetails(getMailContent(valueToLabelMap[changeStep]));
    setEditorKey(prev => prev + 1); // force Editor re-render
  }
}, [editorModal]);

  const getPlainText = (html) => {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    return tempElement.innerText || tempElement.textContent;
  };
  const handleRemove = (uid) => {
    setFileList(fileList.filter((item) => item.uid !== uid));
  };

  const handleUpload = ({ file, onSuccess }) => {
    if (fileList?.length >= 7) {
      console.warn("Maximum 3 files can be uploaded.");
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64Data = reader.result.split(",")[1];
      onSuccess();
      setFileList([
        ...fileList,
        {
          uid: file.uid,
          base64Data: base64Data,
          contentType: file.type,
          fileName: file.name,
        },
      ]);
    };
    reader.onerror = (error) => {
      console.error("File read error:", error);
    };
  };
  const beforeUpload = (file) => {
    const isUnderSizeLimit = file.size / 1024 / 1024 < 25;
    const isNotVideo = !file.type.startsWith("video/");
    if (!isNotVideo) {
      message.error("Video files are not allowed");
      return Upload.LIST_IGNORE;
    }
    if (!isUnderSizeLimit) {
      message.error("File size must be less than 25MB");
      return Upload.LIST_IGNORE;
    }
    if (fileList?.length >= 7) {
      return false;
    }
    return true;
  };
  // console.log("appealDetails--->", appealDetails);

  const handleSendEmail = async () => {
    // console.log("selectedCandidate121--->", selectedCandidate)
    updateProcessingModal(true);
    const subjectValue = form.getFieldValue("subject") || "";
    const bodyValue = form.getFieldValue("bodyText") || "";
    let position = "";
    if (valueToLabelMap[changeStep] === "Selected") {
      const match = (appealDetails || "").match(/Position:\s*([^\n<]+)/i);
      if (match && match[1]) {
        position = match[1].trim();
      }
    }
    const obj = {
      // to: selectedCandidate?.emailId || "",
      // subject: formValues?.subject || "",
      // content: appealDetails || "",
      // files: fileList || [],
      // attachments: "",
      emailId: selectedCandidate?.emailId || "",
      applicationstatus: valueToLabelMap[changeStep],
      bodyText: appealDetails || "",
      checkbox: processCheckbox,
      jobId: selectedCandidate?.jobId,
      subject: subjectValue || "",
      position: position,
      currentStatus: changeStep,
      available: false
    };
    // setMovedStatusName(valueToLabelMap[changeStep]);
    console.log("obj--->", obj);
    // await CALL_API(
    //   `recruitment/candidate/${selectedCandidate?.candidateId}`,
    //   "patch",
    //   obj
    // );
    const response = await axios.patch(`https://nz9pn78wqi.execute-api.ap-south-1.amazonaws.com/Prod/recruitment/candidate/${selectedCandidate?.candidateId}`,
        obj,
        {
        headers: {
          Tymeplusjwt: window.localStorage.getItem("token") || "",
        }
      }
    )
    if(response.data.response.code === 200 || response.data.response.code === "SUCCESS"){
      updateProcessingModal(false);
      setEditorModal(false);
      setMovedModal(true);
      message.success("Email sent successfully")
      goBack();
      getData();
    }else{
      setEditorModal(false);
      updateProcessingModal(false);
      goBack();
      getData();
    }
  };

  const items = [
    {
      label: (
        <EmailEditorStyle>
          <div className="button-container">
            <Upload
              key={uploadKey}
              showUploadList={false}
              multiple={true}
              beforeUpload={beforeUpload}
              customRequest={handleUpload}
            >
              {/* <button className="upload-style"> */}
              From device
              {/* </button> */}
            </Upload>
          </div>
        </EmailEditorStyle>
      ),
      key: "1",
    },
    {
      label: <div onClick={() => setHrPolicies(true)}>HR Policies</div>,
      key: "2",
    },
  ];

  // const onClick = ({ key }) => {
  //   message.info(`Click on item ${key}`);
  // };
  const miscellaneousoption = [
    {
      label: "Performance Review and Appraisal Policy",
      value: "Performance Review and Appraisal Policy",
    },
    {
      label: "Workplace Violence Prevention Policy",
      value: "Workplace Violence Prevention Policy",
    },
    {
      label: "Company Property and Equipment Use Policy",
      value: "Company Property and Equipment Use Policy",
    },
    {
      label: "Grievance and Complaint Resolution Policy",
      value: "Grievance and Complaint Resolution Policy",
    },
    {
      label: "Training and Development Policy",
      value: "Training and Development Policy",
    },
    // { label: "Tax Relief", value: "Tax Relief" },
  ];
  return (
    <>
      <Grid container>
        {localCandidateList?.length > 0 && (
          <>
            <Grid item xs={24} sm={24} md={4} lg={2}>
              <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                style={tabheight}
              >
                {localCandidateList?.map((item, index) => (
                  <VerticalTab
                    key={index}
                    label={`${item?.firstName} ${item?.lastName}`}
                    {...a11yProps(index)}
                    className="mt-3"
                  />
                ))}
              </Tabs>
            </Grid>

            <Grid
              item
              xs={24}
              sm={24}
              md={8}
              lg={10}
              sx={{ borderLeft: 2, borderColor: "divider" }}
            >
              {selectedCandidate && (
                <CustomizeTabPanel value={value} index={value}>
                  <div>
                    <Row>
                      <Col lg={5} sm={12}>
                        <h6 className="fw-semibold">
                          <strong>{`${selectedCandidate?.firstName} ${selectedCandidate?.lastName}`}</strong>
                        </h6>
                      </Col>
                      <Col lg={7} sm={12}>
                        <div className="text-end">
                          {activeTab?.toString() !== "4" && (
                            <>
                              <ButtonOutlined
                                onClick={moveToTalentPool}
                                loading={loading}
                              >
                                Add to Talent Pool
                              </ButtonOutlined>
                            </>
                          )}

                          <span className="mx-2">
                            <ButtonOutlined
                              primary
                              onClick={() => {
                                setShowComponent("onboard");
                                onboardCandidate(selectedCandidate);
                              }}
                            >
                              On Board
                            </ButtonOutlined>
                          </span>

                          {activeTab?.toString() !== "4" && (
                            <>
                              <Select
                                defaultValue="Move to"
                                onChange={(val) => handleSelectChange(val)}
                                options={transformedSteps}
                              />
                            </>
                          )}
                        </div>
                      </Col>
                      <SecondSubMenu
                        item={selectedCandidate}
                        jobList={jobList}
                        processList={processList}
                        getProcess={getProcess}
                        statusChange={transformedSteps}
                      />
                    </Row>
                  </div>
                </CustomizeTabPanel>
              )}
              {isEmpty(selectedCandidate) && (
                <div className="mt-5">
                  <Empty />
                </div>
              )}
            </Grid>
          </>
        )}
        {localCandidateList?.length === 0 && (
          <div className="w-100 text-center mt-5">
            <Empty />
          </div>
        )}
      </Grid>

      <Modal
        open={editorModal}
        width={700}
        footer={false}
        onCancel={handleCloseModal}
      >
        <EmailEditorStyle>
          <Form
            form={form}
            layout="vertical"
            onValuesChange={handleValuesChange}
          >
            <div className="">
              <p className="title">
                Email &nbsp;
                <span className="status_name">{`[${
                  valueToLabelMap[getCurrentCandidate?.currentStatus]
                } -> ${valueToLabelMap[changeStep]}]`}</span>
              </p>
              <p className="to_lable">
                To:{" "}
                <span className="emailid_label">
                  {selectedCandidate?.emailId}
                </span>
              </p>
            </div>
            <Form.Item
              name="subject"
              label=""
              rules={[
                {
                  required: false,
                  // pattern: NON_EMPTY_REGEX,
                  message: "Email is required",
                },
              ]}
            >
              <Input placeholder="" />
            </Form.Item>
          </Form>
          <div>
            <div className="Mos">
              <Dropdown menu={{ items }}>
                <a onClick={(e) => e.preventDefault()}>
                  <Space>
                    <UploadIcon className="upload-icon" />
                    &nbsp;Attach File
                    <DownOutlined />
                  </Space>
                </a>
              </Dropdown>
            </div>
            <div>
              <EditorConvertToHTML
                custom="custom"
                key={editorKey}
                onChange={(val) => {
                  setAppealDetails(val);
                }}
                value={appealDetails}
                content={appealDetails}
              />
            </div>
            {fileList.length > 0 && (
              <div className="d-flex align-items-center gap-2 p-2 file_bg">
                {fileList?.map((item, index) => (
                  <div key={index} className="file_list">
                    {item?.fileName}{" "}
                    <span
                      className="mx-2 fileremove"
                      onClick={() => handleRemove(item.uid)}
                      style={{
                        cursor: "pointer",
                        color: "black",
                        marginLeft: "8px",
                        fontSize: "14px",
                      }}
                    >
                      &times;
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="editor_modal_footer">
            <Button className="cancel_button" onClick={handleCloseModal}>
              Cancel
            </Button>
            <Button className="confirm_button" onClick={handleSendEmail}>
              Confirm
            </Button>
          </div>
        </EmailEditorStyle>
      </Modal>

      <Modal
        open={hrPolicies}
        width={500}
        footer={false}
        onCancel={handlePoliciesModal}
      >
        <EmailEditorStyle>
          <div>
            <h2 className="title">Attach HR Policies</h2>
            <p>{`${formValues.policies?.length || 0} Selected`}</p>
            <div>
              <Form
                className=""
                form={form}
                onValuesChange={handleValuesChange}
              >
                <div className="hr_policies_wrapper">
                  <Form.Item
                    label=""
                    className="input_form_label"
                    name="policies"
                    // rules={[
                    //   { required: true, message: "Miscellaneous Option is required" },
                    // ]}
                  >
                    <Checkbox.Group
                      optionType="checkbox"
                      options={miscellaneousoption}
                      className="checkbox_group"
                    />
                  </Form.Item>
                </div>
                <div className="editor_modal_footer">
                  <Button
                    className="cancel_button"
                    onClick={handlePoliciesModal}
                  >
                    Cancel
                  </Button>
                  <Button className="confirm_button">Attach</Button>
                </div>
              </Form>
            </div>
          </div>
        </EmailEditorStyle>
      </Modal>


    </>
  );
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateProcessingModal: toggleProcessingModal,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(VerticalTabs);
